import Vue from 'vue'
import jQuery from 'jquery'

window.$ = window.jQuery = jQuery
Vue.prototype.$ = jQuery
